export const IS_LOCAL = window.location.host.includes('localhost'); // to use locally start WHP via Nebulae
export const IS_STG = window.location.host.includes(
  '.stg-east.frontend.public.atl-paas.net',
);
export const IS_PROD = !IS_LOCAL && !IS_STG;

const detectBaseUrl = () => {
  if (IS_LOCAL) {
    return 'http://localhost:8080';
  }
  return '/gateway/api';
};

const detectIdentityBaseUrl = () => {
  if (IS_PROD) {
    console.log('Use prod identity');
    return 'https://id.atlassian.com';
  }
  console.log('Use staging identity');
  return 'https://id.stg.internal.atlassian.com';
};

console.log(window.location.host);

// Locally you must start WHP through nebulae
export const API_BASE = detectBaseUrl();

export const TEST_ENDPOINT = API_BASE + '/expression/test';

export const ATLASSIAN_IDENTITY_BASE_URL = detectIdentityBaseUrl();
export const LOGOUT_URL = ATLASSIAN_IDENTITY_BASE_URL + '/logout';
export const LOGIN_URL = ATLASSIAN_IDENTITY_BASE_URL + '/login';
